export default "__VITE_ASSET__CyB_Wb6I__"